import { connect } from 'react-redux';
import React from 'react';
import { getIsHotelOnly } from 'src/store/view/selectors';
import PriceFixedButton from '../../components/PriceFixedButton';

import { getInitialPrice, getHotelLink } from '../../store/selectors/hotel';

const mapStateToProps = (state) => ({
  hotelLink: getHotelLink(state),
  price: getInitialPrice(state),
  isHotelOnly: getIsHotelOnly(state),
});

export default connect(mapStateToProps)(React.memo(PriceFixedButton));
